const InfoBanner = () => {
  return (
    <div className="referrals-info-banner">
      Chant is largely free as communities fuel our growth. As a member of our
      Supporter Circle, your group gets full platform access. In return, we work
      together on a few simple milestones to help fuel our shared growth.
    </div>
  );
};

export default InfoBanner;
